import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/main'
Vue.use(VueRouter)

export default new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Main,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'Home',
          meta: {title: '首页', navTitle: '首页', icon: '', noCache: true},
          hidden: false,
          component: (resolve) => require(['@/views/home'], resolve)
        }
      ]
    },
    {
      path: '/application',
      component: Main,
      hidden: true,
      redirect: 'noredirect',
      children: [
        {
          path: 'wire-harness',
          name: 'wire-harness',
          meta: {title: '高压线束', navTitle: '高压线束', icon: '', noCache: true},
          hidden: false,
          component: (resolve) => require(['@/views/wireHarness'], resolve)
        },
        {
          path: 'low-pressure',
          name: 'low-pressure',
          meta: {title: '低压线束', navTitle: '低压线束', icon: '', noCache: true},
          hidden: true,
          component: (resolve) => require(['@/views/lowPressure'], resolve)
        }
      ]
    },
    {
      path: '/',
      component: Main,
      redirect: '/about-us',
      children: [
        {
          path: 'about-us',
          name: 'about-us',
          meta: {title: '关于我们', navTitle: '关于我们', icon: '', noCache: true},
          hidden: false,
          component: (resolve) => require(['@/views/aboutUs'], resolve)
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js